import React, { useEffect, useRef, useState } from 'react';
import * as Styled from './styled';
import { ShowMore } from 'screens/ShortlistPage/styled';
import { ShowMoreWrapper } from '../../sections/about/styled';
import ChevronUp from 'assets/svg/chevron-up.svg';
import { useLocale } from 'locale';


interface DescriptionProps {
  lineHeight?: number;
  maxLines?: number;
  content: string;
  showOnClick: boolean;
}

export const Description: React.FC<DescriptionProps> = (props) => {
  const {
    lineHeight = 24,
    maxLines = 9,
    content,
    showOnClick,
  } = props;

  const { t } = useLocale();
  const refWrapper = useRef<HTMLDivElement>();
  const [ showToggle, setShowToggle ] = useState(null);
  const [ isOpen, setIsOpen ] = useState(true);

  useEffect(() => {
    if (refWrapper) {
      // +1 because we use space for toggle link
      const toggleState = refWrapper.current.getBoundingClientRect().height / lineHeight > (maxLines + 1);
      setShowToggle(toggleState);
      setIsOpen(!toggleState);
    }
  }, []);

  return (
    <div>
      <Styled.TextWrapper onClick={showOnClick ? () => setIsOpen(true) : undefined} ref={refWrapper} lines={isOpen ? null : maxLines} dangerouslySetInnerHTML={{ __html: content }} />
      {showToggle ? (
        <ShowMoreWrapper isOpen={isOpen} isDesktop={true}>
          <ShowMore disableMargin onClick={() => setIsOpen(!isOpen)}>
            <>{t(isOpen ? 'collapsable.showLess' : 'collapsable.showMore')}<ChevronUp/></>
          </ShowMore>
        </ShowMoreWrapper>
      ) : null}
    </div>
  );
};
